import { render, staticRenderFns } from "./defaultroutingrules.vue?vue&type=template&id=4ded9f02"
import script from "./defaultroutingrules.vue?vue&type=script&lang=js"
export * from "./defaultroutingrules.vue?vue&type=script&lang=js"
import style0 from "./defaultroutingrules.vue?vue&type=style&index=0&id=4ded9f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports